import UaaContainer from './UaaContainer'

export default UaaContainer
